export default "__VITE_ASSET__1abab2eb__"